import { ReceiptType } from '@hooks-api/types/dataModel/eCommercePayments'
import { validatePhoneCarrierNumber, validateTaxID } from '@utils'
import { z } from 'zod'

export const invoiceSchema = z.object({
  receiptType: z.nativeEnum(ReceiptType).nullable(),
  businessUbnTitle: z.string().optional(),
  businessUbn: z.string().optional(),
  phoneCarrierNumber: z.string().optional(),
  isOfflinePayment: z.boolean(),
})
  .refine(data => !(!data.isOfflinePayment && data.receiptType === ReceiptType.BUSINESS_EINVOICE && !data.businessUbn), {
    message: '請輸入統一編號',
    path: ['businessUbn'],
  })
  .refine(data => !(!data.isOfflinePayment && data.receiptType === ReceiptType.BUSINESS_EINVOICE && !validateTaxID(data.businessUbn)), {
    message: '統一編號格式錯誤！請輸入8碼半型數字',
    path: ['businessUbn'],
  })
  .refine(data => !(!data.isOfflinePayment && data.receiptType === ReceiptType.PHONE_CARRIER && !data.phoneCarrierNumber), {
    message: '必填欄位',
    path: ['phoneCarrierNumber'],
  })
  .refine(data => !(!data.isOfflinePayment && data.receiptType === ReceiptType.PHONE_CARRIER && (!data.phoneCarrierNumber || !validatePhoneCarrierNumber(data.phoneCarrierNumber))), {
    message: '請輸入完整後 7 碼：限數字 0-9、大寫英文 A-Z 及 + - .',
    path: ['phoneCarrierNumber'],
  })
